import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useLines } from '@/hooks/v1';
import { toOptions } from '@/views/Bera/_components/Filter/utils';
import { useApplicationContext } from '@/context/v1/Application/context';
import { HierarchySelect } from '@/views/Bera/_components/Filter/Fields/HierarchySelect';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance, useWatch } = Form;

export function Line(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();
	const { organization } = useApplicationContext();

	const companyId = useWatch('company_id_filter', form);
	const sectorId = useWatch('sector_id', form);

	const {
		data: lines,
		isLoading,
		isFetching,
		isError
	} = useLines({
		organization_id: organization?.id,
		company_id: companyId,
		sector_id: sectorId
	});

	function handleChange(): void {
		const clearedFields = { workstation_id: undefined };

		form.setFieldsValue(clearedFields);
	}

	return (
		<Col xs={24}>
			<Form.Item name="line_id" label={I18n.get('Line')} labelCol={{ span: 24 }}>
				<HierarchySelect
					onChange={handleChange}
					loading={isFetching}
					options={toOptions(lines)}
					placeholder={I18n.get('Line')}
					disabled={isLoading || isFetching || isError || !sectorId}
				/>
			</Form.Item>
		</Col>
	);
}
